import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";

interface TrainingGameCardProps {
  id?: string;
  abilities?: any;
  name: string | null;
  image: string | undefined;
  onClick: any;
}

export const TrainingGameCard = ({
  name,
  image,
  onClick,
  abilities,
}: TrainingGameCardProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        border: "solid 1px #00000021",
        borderRadius: "13px",
        width: "100%",
        maxHeight: "320px",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: 176,
          position: "relative",
          overflow: "hidden",
          borderRadius: "13px 13px 0 0",

          "&:hover .play-button": {
            opacity: 2,
            visibility: "visible",
          },

          "&:hover img": {
            filter: "brightness(0.2)",
          },
        }}
      >
        <img
          src={image}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />

        <Box
          className="play-button"
          onClick={onClick}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            width: 150,
            height: 44,

            opacity: 0,
            visibility: "hidden",
            transition: "all .3s ease",
            borderRadius: "25px",
            border: "3px solid #fff",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            color: "#fff",
            cursor: "pointer",
            textTransform: "uppercase",
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          Jogar
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "15px",
          gap: "10px",
          maxWidth: "349px",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "18px", sm: "21px" },
            fontWeight: 600,
            color: "#3D3F40",
          }}
        >
          {name}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "rown", sm: "column" },
            alignItems: { xs: "center", sm: "start" },
            gap: "5px",
            flexWrap: "wrap",
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              textTransform: "uppercase",
              color: "#24292A73",
            }}
          >
            {t("global.you_will_train")}
          </Typography>
          <Box>
            {abilities.map((ability: any) => (
              <Chip
                key={ability}
                label={ability}
                sx={{
                  backgroundColor: "#2CA6A42B",
                  color: "#319C9A",
                  fontWeight: 500,
                  marginRight: "5px",
                  marginTop: "10px",
                  fontSize: { xs: "12px", md: "14px" },
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
